import React from 'react';
import { observer } from 'mobx-react';
import { Selected, OwnerAvatar } from 'libs/forms/styles';
import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';

export const SpaceComponent = observer(({ selected, fieldStore }) => {
  const text =
    selected.spaceType === 'INITIATIVE' && selected.title
      ? selected.title
      : selected[fieldStore.conf.labelKey];
  return (
    <Selected color={selected[fieldStore.conf.appKey]}>
      <OwnerAvatar
        size='22px'
        src={imageSrc(
          selected.content.avatar,
          selected.content.imageFallbackPath,
          mainConf.imgSizes.profile.small,
        )}
        noMarginTop
      />
      {text}
    </Selected>
  );
});
